import React from "react";
import styles from "./Panel.module.css";

interface PanelProps {
  children: React.ReactNode;
  className?: string; // Allow consumers to pass additional classes
  // Add other common panel props if needed, e.g., paddingLevel, shadowLevel
}

const Panel: React.FC<PanelProps> = ({ children, className }) => {
  return <div className={`${styles.panel} ${className || ""}`}>{children}</div>;
};

export default Panel;
